import { SmartAppBannerLazyLoaderV2 } from './smartAppBannerLazyLoaderV2';

const props = [];

export const SmartAppBannerDirective = reactDirective => reactDirective(SmartAppBannerLazyLoaderV2, props);
SmartAppBannerDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('smartAppBannerV2', SmartAppBannerDirective);
